import { ApolloLink, Observable } from "@apollo/client";
import { API_URL } from "../constant";

export const httpLink = new ApolloLink((operation) => {
  return new Observable((observer) => {
    const {
      headers = {},
      encryptedBody,
      bypassEncryption,
    } = operation.getContext();

    const uri = `${API_URL.GETWAY_API}api/v1`;

    const finalBody =
      !bypassEncryption && encryptedBody
        ? JSON.stringify(encryptedBody)
        : JSON.stringify({
            query: operation.query.loc.source.body,
            variables: operation.variables,
            operationName: operation.operationName,
          });

    const finalHeaders = {
      "Content-Type": "application/json",
      ...headers,
    };

    if (bypassEncryption) {
      delete finalHeaders.is_encrypt_response;
    }

    const controller = new AbortController();

    fetch(uri, {
      method: "POST",
      headers: finalHeaders,
      body: finalBody,
      signal: controller.signal,
    })
      .then(async (response) => {
        if (!response.ok) {
          const serverError = {
            name: "ServerError",
            message: response.statusText,
            statusCode: response.status,
            response,
            result: await response.json().catch(() => null),
          };

          throw serverError;
        }
        return response.json();
      })
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((err) => observer.error(err));

    return () => {
      controller.abort();
    };
  });
});
